import * as React from 'react';
import { observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../../routes';
import { ReservationErrorPane } from '../../molecules/reservations/ReservationErrorPane';
import { parseQueryParams } from '../../../types/location';

type Props = {
    match: {
        url: string;
        params: {
            sessionId: string;
        };
    };
};

@observer
export class SessionReservationErrorPane extends React.Component<Props> {
    render() {
        const { message } = parseQueryParams(GlobalStatesV3.routing.location);
        return (
            <ReservationErrorPane
                onCompleteClick={() => GlobalStatesV3.routing.push(V3Routes.home())}
                message={message}
            />
        );
    }
}
